import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bin = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6 6v12a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6M6 6h12M6 6H4m14 0h2M9 6a3 3 0 1 1 6 0m-1 5v5m-4-5v5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.325 5a3.751 3.751 0 0 1 7.35 0h4.575a.75.75 0 0 1 0 1.5H19v12.75A2.75 2.75 0 0 1 16.25 22h-8.5A2.75 2.75 0 0 1 5 19.25V6.5H3.75a.75.75 0 0 1 0-1.5zm1.553 0a2.25 2.25 0 0 1 4.244 0zM10 10a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 10 10m4 0a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 14 10'
        fill='currentColor'
      />
    )}
  </IconBase>
);
